export default "__VITE_ASSET__D2rM5WOI__"